/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  price arrays for ads
 */

export const PRICE_0_1000 = '0 - 1000'
export const PRICE_1000_2000 = '1000 - 2000'
export const PRICE_2000_3000 = '2000 - 3000'
export const PRICE_3000_4000 = '3000 - 4000'
export const PRICE_4000_5000 = '4000 - 5000'
export const PRICE_5000_PLUS = '5000+'
export const UNSET_PRICE_FILTER = [
  PRICE_0_1000,
  PRICE_1000_2000,
  PRICE_2000_3000,
  PRICE_3000_4000,
  PRICE_4000_5000,
  PRICE_5000_PLUS,
]
